import { render, staticRenderFns } from "./IbGridViewPlaceholder.vue?vue&type=template&id=36c4eb51"
import script from "./IbGridViewPlaceholder.vue?vue&type=script&lang=js"
export * from "./IbGridViewPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports